import { render, staticRenderFns } from "./PageSetDialog.vue?vue&type=template&id=f5cf67f4&"
import script from "./PageSetDialog.vue?vue&type=script&lang=js&"
export * from "./PageSetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5cf67f4')) {
      api.createRecord('f5cf67f4', component.options)
    } else {
      api.reload('f5cf67f4', component.options)
    }
    module.hot.accept("./PageSetDialog.vue?vue&type=template&id=f5cf67f4&", function () {
      api.rerender('f5cf67f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/PageSetDialog.vue"
export default component.exports